import { useEffect } from "react";
import { doc, onSnapshot, collection,where, query, orderBy } from "firebase/firestore";
import { db } from "../firebase/firebase";
import usefbStore from "../store/firebasestore";

function Protected({ children }) {
  const userID = usefbStore((s) => s.userID);
  const authStatus = usefbStore((s) => s.authStatus);
  const setJobApplications = usefbStore((s) => s.setJobApplications);
  const setAccountPoints = usefbStore((s) => s.setAccountPoints);
  const setUserName = usefbStore((s) => s.setUserName);
  const setScreeningActive = usefbStore((s) => s.setScreeningActive);
  const setScreenCount = usefbStore((s) => s.setScreenCount);
  const setAccountBalance = usefbStore((s) => s.setAccountBalance);
  const setScreeningTest = usefbStore((s) => s.setScreeningTest);
  const setTransactions = usefbStore((s) => s.setTransactions);
  const setUserEmail = usefbStore((s) => s.setUserEmail);
  const setSolaraTokens = usefbStore((s) => s.setSolaraTokens);
  const setAccountVerified = usefbStore((s) => s.setAccountVerified);
  const setSetPaymentMethod = usefbStore((s) => s.setSetPaymentMethod);
  const setCryptoDetails = usefbStore((s) => s.setCryptoDetails);
  const setBankDetails = usefbStore((s) => s.setBankDetails);
  const setSecApproval = usefbStore((s) => s.setSecApproval);
  const setPaypalDetails = usefbStore((s)=> s.setPaypalDetails)
  const setPaymentMethod = usefbStore((s) => s.setPaymentMethod);
  const setJobArray = usefbStore((s) => s.setJobArray);
  const setrealName = usefbStore((s) => s.setRealName);
  const setRegion = usefbStore((s) => s.setRegion);
  const setIsReverified = usefbStore((s)=>s.setIsReverified)
  const setActiveSince = usefbStore((s) => s.setActiveSince);
  
  // ✅ NEW: WithdrawRequests state setter
  const setWithdrawRequests = usefbStore((s) => s.setWithdrawRequests);

  // ✅ NEW: Cooldown setters
  const setTaskCooldownUntil = usefbStore((s) => s.setTaskCooldownUntil);
  const resetCooldown = usefbStore((s) => s.resetCooldown);

  useEffect(() => {
    if (authStatus !== "authenticated" || !userID) return;

    // 1️⃣ User Document Listener
    const userRef = doc(db, "Users", userID);
    const unsubscribeUser = onSnapshot(userRef, (snap) => {
      if (!snap.exists()) return;
      const data = snap.data();
      setUserName(data.name);
      setIsReverified(data.isReverified);
      setrealName(data.kycName);
      setRegion(data.kycRegion);
      setActiveSince(data.lastVerificationTimestamp);
      setSecApproval(data.secApproval);
      setScreeningTest(data.screeningTest);
      setScreeningActive(data.screeningActive);
      setSolaraTokens(data.solaraTokens);
      setScreenCount(data.screenCount);
      setAccountPoints(data.accountPoints);
      setUserEmail(data.em);
      setAccountBalance(data.accountBalance);
      setAccountVerified(data.accountVerified);
      setSetPaymentMethod(data.paymentMethodSet);
      setPaymentMethod(data.paymentMethod);
      setBankDetails(data.bankDetails);
      setCryptoDetails(data.cryptoDetails);
      setPaypalDetails(data.paypalDetails)

      // Listen for cooldown field from Firestore
      if (data.taskCooldownUntil) {
        setTaskCooldownUntil(data.taskCooldownUntil.toDate());
      } else {
        resetCooldown();
      }
    });

    // 2️⃣ Transactions Listener
    const transactionsRef = collection(db, "Users", userID, "transactions");
    const transactionsQuery = query(transactionsRef, orderBy("createdAt", "desc"));
    
    const unsubscribeTransactions = onSnapshot(transactionsQuery, (snapshot) => {
      const txArray = [];
      snapshot.forEach((doc) => {
        txArray.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      setTransactions(txArray);
    });

    // 3️⃣ Jobs Listener
    const jobsRef = collection(db, "JobsX");
    const unsubscribeJobs = onSnapshot(jobsRef, (snapshot) => {
      const jobsArray = [];
      snapshot.forEach((job) => {
        jobsArray.push({
          id: job.id,
          ...job.data(),
        });
      });
      setJobArray(jobsArray);
    });

   // ✅ 4️⃣ NEW: WithdrawRequests Listener (based on your actual structure)
const withdrawRequestsRef = collection(db, "WithdrawRequests");
const withdrawRequestsQuery = query(withdrawRequestsRef);

const unsubscribeWithdrawRequests = onSnapshot(withdrawRequestsQuery, (snapshot) => {
  const requestsArray = [];
  snapshot.forEach((doc) => {
    const data = doc.data();
    
    // Parse bankDetails and cryptoDetails if they are stringified JSON
    let parsedBankDetails = data.bankDetails;
    let parsedCryptoDetails = data.cryptoDetails;
    let parsedPaypalDetails = data.paypalDetails;
    
    try {
      if (typeof data.bankDetails === 'string' && data.bankDetails !== "") {
        parsedBankDetails = JSON.parse(data.bankDetails);
      }
    } catch (e) {
    }
    
    try {
      if (typeof data.cryptoDetails === 'string' && data.cryptoDetails !== "") {
        parsedCryptoDetails = JSON.parse(data.cryptoDetails);
      }
    } catch (e) {
    }

    try {
      if (typeof data.paypalDetails === 'string' && data.paypalDetails !== "") {
        parsedPaypalDetails = JSON.parse(data.paypalDetails);
      }
    } catch (e) {
    }
  
    requestsArray.push({
      id: doc.id,
      uid: data.uid,
      amount: data.amount,
      name: data.name,
      status: data.status,
      withdrawMethod: data.withdrawMethod,
      bankDetails: parsedBankDetails,
      cryptoDetails: parsedCryptoDetails,
      paypalDetails: parsedPaypalDetails,

      email:data.email,
      createdAt: data.createdAt,
    });
  });
  
  setWithdrawRequests(requestsArray);
});

// 5️⃣ User Applied Jobs Listener

const applicationsRef = collection(db, "JobApplications");

const applicationsQuery = query(
  applicationsRef,
  where("userId", "==", userID)
);

const unsubscribeApplications = onSnapshot(
  applicationsQuery,
  (snapshot) => {
    const applications = [];

    snapshot.forEach((docSnap) => {
      const data = docSnap.data();

      if (data.jobId) {
        applications.push({
          id: docSnap.id,
          ...data,
        });
      }
    });

    setJobApplications(applications);
  }
);
    // Cleanup all listeners on unmount
    return () => {
      unsubscribeUser();
      unsubscribeTransactions();
      unsubscribeJobs();
      unsubscribeWithdrawRequests();
      unsubscribeApplications();
    };
  }, [userID, authStatus]);

  return children;
}
export default Protected;